import { Component, OnInit } from '@angular/core';
import { BaseProductPickerSearchCriteriaComponent } from './base-product-picker-search-criteria.component';
import { ReferenceData } from './../../../lib/models/reference-data.model';
import { ReferenceDataService } from './../../../lib/services/reference-data.service';
import { moveConfigItemToFirstPosition } from './../../../lib/functions/generic';

@Component({
  selector: 'boi-product-picker-search-criteria',
  templateUrl: './product-picker-search-criteria.component.html',
  styleUrls: ['./product-picker-search-criteria.component.scss']
})
export class ProductPickerSearchCriteriaComponent extends BaseProductPickerSearchCriteriaComponent implements OnInit {
  public EPCRatingOptionList: ReferenceData[];
  public isEpcRatingFieldDisabled: boolean = false;
  public isEpcDateIssuedDisabled: boolean = false;

  constructor(private readonly referenceDataService: ReferenceDataService) {
    super();
  }

  ngOnInit(): void {
    this.setEPCRatingOptionList();
    this.setEpcRatingFieldsAvailability();
  }

  private setEpcRatingFieldsAvailability(): void {
    if (this.filter.PropertyEPCRatingCode) {
      this.isEpcRatingFieldDisabled = true;
    }

    if (this.filter.EPCDateIssued) {
      this.isEpcDateIssuedDisabled = true;
    }
  }

  public displayEPCDateIssued(): boolean {
    return (
      this.filter.PropertyEPCRatingCode !== this.referenceDataOptionLists.EPCRatingUnknown &&
      this.filter.PropertyEPCRatingCode !== this.referenceDataOptionLists.EPCRatingExpired &&
      this.filter.PropertyEPCRatingCode !== this.referenceDataOptionLists.EPCRatingExempt
    );
  }

  private setEPCRatingOptionList(): void {
    if (this.filter.Filter.PurchaseOrRemortgageCode === this.referenceDataLabels.PurchaseId) {
      if (this.filter.Filter.LoanGroupTypeCode === this.referenceDataOptionLists.LoanGroupTypeResidential) {
        this.EPCRatingOptionList = this.referenceDataService.getOptionListConfigItems(
          this.referenceDataOptionLists.EPCRatingResidentialPurchase
        );
      } else {
        this.EPCRatingOptionList = this.referenceDataService.getOptionListConfigItems(
          this.referenceDataOptionLists.EPCRatingBTLPurchase
        );
      }
    } else {
      if (this.filter.Filter.LoanGroupTypeCode === this.referenceDataOptionLists.LoanGroupTypeResidential) {
        this.EPCRatingOptionList = this.referenceDataService.getOptionListConfigItems(
          this.referenceDataOptionLists.EPCRatingResidentialRemortgage
        );
      } else {
        this.EPCRatingOptionList = this.referenceDataService.getOptionListConfigItems(
          this.referenceDataOptionLists.EPCRatingBTLRemortgage
        );
      }
    }

    this.EPCRatingOptionList = moveConfigItemToFirstPosition(
      this.EPCRatingOptionList,
      this.referenceDataOptionLists.EPCRatingUnknown
    );
  }
}
